var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialLinkedin20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Commbank-Footer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "md---768---977---New-footer",
    transform: "translate(-504.000000, -416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin-icon",
    transform: "translate(504.000000, 416.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,22 C17.0762582,22 22,17.0749647 22,11 C22,4.92503528 17.0762582,0 11,0 C4.92503528,0 0,4.92503528 0,11 C0,17.0749647 4.92503528,22 11,22",
    id: "Fill-1",
    fill: "#1485C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7614269,15.8404107 L14.272498,15.8404107 L14.272498,12.2053428 C14.272498,11.2538688 13.8831683,10.6043239 13.0270403,10.6043239 C12.3721984,10.6043239 12.0080295,11.0426508 11.8385254,11.4650867 C11.7749614,11.6167134 11.7848933,11.8279314 11.7848933,12.0391494 L11.7848933,15.8404107 L9.31913868,15.8404107 C9.31913868,15.8404107 9.35092069,9.40124221 9.31913868,8.81592346 L11.7848933,8.81592346 L11.7848933,9.91836207 C11.9305608,9.43633485 12.7184899,8.74838668 13.976528,8.74838668 C15.535833,8.74838668 16.7614269,9.75878987 16.7614269,11.9345336 L16.7614269,15.8404107 Z M6.82557483,7.9372832 L6.80968383,7.9372832 C6.01513348,7.9372832 5.5,7.40029958 5.5,6.71963479 C5.5,6.02572748 6.03102448,5.5 6.84080371,5.5 C7.65058294,5.5 8.14850116,6.02440323 8.16439217,6.71764841 C8.16439217,7.39831321 7.65058294,7.9372832 6.82557483,7.9372832 L6.82557483,7.9372832 Z M5.78338962,15.8404107 L7.97899709,15.8404107 L7.97899709,8.81592346 L5.78338962,8.81592346 L5.78338962,15.8404107 Z",
    id: "Fill-4",
    fill: "#FEFEFE"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin20);
export default __webpack_public_path__ + "static/media/socialLinkedin20.bdc37a57e3f1f7ed0801da8d21e65d08.svg";
export { ForwardRef as ReactComponent };